import { useState, useEffect } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { getTeachers } from "../../../ApiService/ApiService";
import TeacherTable from "./TeacherTable";
import AddTeacher from "./AddTeacher";
import { Add } from "@mui/icons-material";

function TeachersSection() {
  const [teachers, setTeachers] = useState({});
  const [showAddTeacher, setShowAddTeacher] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchTeachers();
  }, []);

  const fetchTeachers = async () => {
    try {
      setLoading(true);
      const response = await getTeachers();
      setTeachers(response?.data);
    } catch (err) {
      console.error("Error fetching teachers details:", err);
    } finally {
      setLoading(false);
    }
  };

  const renderMainContent = () => {
    if (showAddTeacher) {
      return (
        <AddTeacher
          fetchTeachers={fetchTeachers}
          setShowAddTeacher={setShowAddTeacher}
        />
      );
    } else {
      return <TeacherTable teachers={teachers} fetchTeachers={fetchTeachers} />;
    }
  };

  return (
    <>
      <Box
        sx={{
          display: showAddTeacher ? "none" : "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography
          paragraph
          sx={{ color: "black", fontWeight: 600, fontSize: 22 }}
          xs={4}
          sm={4}
          md={6}
          lg={8}
          xl={8}
        >
          Teachers
        </Typography>
        <Button
          xs={8}
          sm={8}
          md={6}
          lg={4}
          xl={4}
          onClick={() => setShowAddTeacher(true)}
          variant="contained"
          color="primary"
          size="small"
          sx={{
            mb: 2,
            textTransform: "unset",
            borderRadius: 2,
          }}
        >
          <Add fontSize="small" />
          Add Teacher
        </Button>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>{renderMainContent()}</>
      )}
    </>
  );
}

export default TeachersSection;
